export default {
  'app.setting.pagestyle': '整体风格设置',
  'app.setting.pagestyle.light': '亮色主题风格',
  'app.setting.pagestyle.dark': '暗色主题风格',
  'app.setting.pagestyle.realdark': '暗黑模式',
  'app.setting.layout.side': '侧边菜单布局',
  'app.setting.layout.top': '顶部菜单布局',
  'app.setting.layout.mix': '混合布局',
  'app.setting.layout.leftmenu': '左侧混合布局',
  'app.setting.layout.mix.hint': '将菜单分割成 Header 和 Side',
  'app.setting.themecolor': '主题色',
  'app.setting.themecolor.dust': '薄暮',
  'app.setting.themecolor.volcano': '火山',
  'app.setting.themecolor.sunset': '日暮',
  'app.setting.themecolor.cyan': '明青',
  'app.setting.themecolor.green': '极光绿',
  'app.setting.themecolor.daybreak': '拂晓蓝（默认）',
  'app.setting.themecolor.geekblue': '极客蓝',
  'app.setting.themecolor.purple': '酱紫',
  'app.setting.navigationmode': '导航模式',
  'app.setting.content-width': '内容区域宽度',
  'app.setting.fixedheader': '固定 Header',
  'app.setting.fixedheader.hint': '混合模式必须开启固定 Header',
  'app.setting.fixedsidebar': '固定侧边菜单',
  'app.setting.fixedsidebar.hint': '',
  'app.setting.split.menus': '自动分割菜单',
  'app.setting.content-width.fixed': '固定宽度',
  'app.setting.content-width.fluid': '自适应',
  'app.setting.othersettings': '其他设置',
  'app.setting.weakmode': '色弱模式',
  'app.setting.transitionname': '路由动画',
  'app.setting.multitab': '多标签',
  'app.setting.multitab.fixed': '固定多标签',
  'app.setting.multitab.fixed.hit': '固定多标签需要先开启多标签并且固定 Header',
  'app.setting.unavailable': '不可用',
  'app.setting.copy': '复制设置',
  'app.setting.loading': '主题加载中',
  'app.setting.copyinfo':
    '拷贝成功，请到 src/components/basic-layout/defaultSettings.ts 中替换默认配置',
  'app.setting.production.hint':
    'Setting panel shows in development environment only, please manually modify',
};
